import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, input, Input, output, ViewChild } from '@angular/core';
import { Menu, MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { SpinnerComponent } from '../../misc/spinner/spinner.component';
import { TooltipDirective } from '../../overlay/tooltip/tooltip.directive';
import { MenuAppendTo } from './contract/menu-append-to.contract';
import { MenuAriaLabel } from './contract/menu-aria-label.contract';
import { MenuAriaLabelledBy } from './contract/menu-aria-labelled-by.contract';
import { MenuId } from './contract/menu-id.contract';
import { MenuModel } from './contract/menu-model.contract';
import { MenuPopup } from './contract/menu-popup.contract';
import { MenuStyleClass } from './contract/menu-style-class.contract';

@Component({
  selector: 'osp-menu',
  standalone: true,
  imports: [MenuModule, RippleModule, NgClass, TooltipDirective, SpinnerComponent, NgStyle],
  templateUrl: './menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  @ViewChild('menu') menu!: Menu;
  @HostBinding('class') protected cssClass = 'osp-menu';

  @Input() model: MenuModel = [];
  @Input() popup?: MenuPopup;
  @Input() ariaLabel?: MenuAriaLabel;
  @Input() ariaLabelledBy?: MenuAriaLabelledBy;
  @Input() id?: MenuId;
  @Input() appendTo?: MenuAppendTo = 'body';
  @Input() styleClass?: MenuStyleClass;
  $loading = input<boolean>(false, { alias: 'loading' });

  $onShow = output<void>({ alias: 'onShow' });
  $onHide = output<void>({ alias: 'onHide' });

  public toggle(event: Event) {
    this.menu.toggle(event);
  }

  public show(event: Event) {
    this.menu.show(event);
  }

  public hide() {
    this.menu.hide();
  }

  public onMenuItemClick(event: Event, id: string) {
    this.menu.itemClick(event, id);
  }
}
